import BaseErrorCard from 'reservations/base/components/BaseErrorCard';

type ReservationNotFoundErrorProps = {
  slug: string;
};

const RESERVATION_NOT_FOUND_CONTENT =
  "We couldn't find a reservation with this URL. Please try navigating to your reservation from your confirmation email.";

function ReservationNotFoundError({ slug }: ReservationNotFoundErrorProps) {
  // TODO: We may want to revisit this component in the future
  // because of the fact that we're adding a `linkHref` which feels too specific
  // for our proposed component library
  return (
    <BaseErrorCard
      title="No Reservation Found"
      content={RESERVATION_NOT_FOUND_CONTENT}
      linkText="Make a New Reservation"
      linkHref={`/locations/${slug}`}
    />
  );
}

export default ReservationNotFoundError;
